/* eslint-disable @typescript-eslint/consistent-type-assertions , @typescript-eslint/consistent-type-definitions , @typescript-eslint/no-unnecessary-condition , @typescript-eslint/no-unnecessary-type-arguments , antfu/top-level-function , @typescript-eslint/no-misused-spread */
/**
 * Generated by orval 🍺
 * Do not edit manually!
 * todomvp
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/vue-query";
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import { unref } from "vue";
import type { MaybeRef } from "vue";

/**
 * Api already exists conflict.
 */
export type ApiErrorOneOf = {
  /** Api already exists conflict. */
  Conflict: string;
};

/**
 * Object not found by id.
 */
export type ApiErrorOneOfTwo = {
  /** Object not found by id. */
  NotFound: string;
};

/**
 * Api operation unauthorized
 */
export type ApiErrorOneOfThree = {
  /** Api operation unauthorized */
  Unauthorized: string;
};

export type ApiErrorOneOfFour = {
  InvalidData: string;
};

/**
 * Api operation errors
 */
export type ApiError =
  | ApiErrorOneOf
  | ApiErrorOneOfTwo
  | ApiErrorOneOfThree
  | ApiErrorOneOfFour;

export interface LatestMeasurement {
  id: string;
  significand: number;
}

export interface Measurement {
  definition: string;
  significand: number;
}

export type MeasurementDefinitionMaximum = number | null;

export type MeasurementDefinitionMinimum = number | null;

export type MeasurementDefinitionStep = number | null;

export interface MeasurementDefinition {
  exponent: number;
  id: string;
  maximum?: MeasurementDefinitionMaximum;
  minimum?: MeasurementDefinitionMinimum;
  name: string;
  step?: MeasurementDefinitionStep;
  unit: Unit;
}

export type MeasurementDefinitionWithLatestMeasurementLatest =
  null | LatestMeasurement;

export interface MeasurementDefinitionWithLatestMeasurement {
  count: number;
  definition: MeasurementDefinition;
  latest?: MeasurementDefinitionWithLatestMeasurementLatest;
}

export interface NewTodo {
  value: string;
}

export interface Observation {
  data: ObservationData;
  id: string;
}

export type ObservationDataOneOf = {
  Text: string;
};

export type ObservationDataOneOfTwo = {
  Measurement: Measurement;
};

export type ObservationData = ObservationDataOneOf | ObservationDataOneOfTwo;

/**
 * Item to do.
 */
export interface Todo {
  description: string;
  done: boolean;
  id: string;
}

export type Unit = (typeof Unit)[keyof typeof Unit];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Unit = {
  None: "None",
  Kilogram: "Kilogram",
  Meter: "Meter",
} as const;

/**
 * List all measurement_definitions.
 * @summary List all measurement_definitions
 */
export const measurementDefinitionsList = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MeasurementDefinition[]>> => {
  return axios.default.get(`/v1/measurement_definitions`, options);
};

export const getMeasurementDefinitionsListQueryKey = () => {
  return ["v1", "measurement_definitions"] as const;
};

export const getMeasurementDefinitionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof measurementDefinitionsList>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof measurementDefinitionsList>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getMeasurementDefinitionsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof measurementDefinitionsList>>
  > = ({ signal }) => measurementDefinitionsList({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof measurementDefinitionsList>>,
    TError,
    TData
  >;
};

export type MeasurementDefinitionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof measurementDefinitionsList>>
>;
export type MeasurementDefinitionsListQueryError = AxiosError<unknown>;

/**
 * @summary List all measurement_definitions
 */

export function useMeasurementDefinitionsList<
  TData = Awaited<ReturnType<typeof measurementDefinitionsList>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof measurementDefinitionsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMeasurementDefinitionsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * Tries to create a new measurement_definition item to storage or fails with 409 conflict if already exists.
 * @summary Create a new measurement_definition
 */
export const measurementDefinitionsCreate = (
  measurementDefinition: MaybeRef<MeasurementDefinition>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MeasurementDefinition>> => {
  measurementDefinition = unref(measurementDefinition);

  return axios.default.post(
    `/v1/measurement_definitions`,
    measurementDefinition,
    options,
  );
};

export const getMeasurementDefinitionsCreateMutationOptions = <
  TError = AxiosError<ApiError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof measurementDefinitionsCreate>>,
    TError,
    { data: MeasurementDefinition },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof measurementDefinitionsCreate>>,
  TError,
  { data: MeasurementDefinition },
  TContext
> => {
  const mutationKey = ["measurementDefinitionsCreate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof measurementDefinitionsCreate>>,
    { data: MeasurementDefinition }
  > = (props) => {
    const { data } = props ?? {};

    return measurementDefinitionsCreate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MeasurementDefinitionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof measurementDefinitionsCreate>>
>;
export type MeasurementDefinitionsCreateMutationBody = MeasurementDefinition;
export type MeasurementDefinitionsCreateMutationError = AxiosError<ApiError>;

/**
 * @summary Create a new measurement_definition
 */
export const useMeasurementDefinitionsCreate = <
  TError = AxiosError<ApiError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof measurementDefinitionsCreate>>,
      TError,
      { data: MeasurementDefinition },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof measurementDefinitionsCreate>>,
  TError,
  { data: MeasurementDefinition },
  TContext
> => {
  const mutationOptions =
    getMeasurementDefinitionsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List the latest measurement for each definition
 * @summary List the latest measurement for each definition
 */
export const measurementDefinitionsLatest = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MeasurementDefinitionWithLatestMeasurement[]>> => {
  return axios.default.get(`/v1/measurement_definitions/latest`, options);
};

export const getMeasurementDefinitionsLatestQueryKey = () => {
  return ["v1", "measurement_definitions", "latest"] as const;
};

export const getMeasurementDefinitionsLatestQueryOptions = <
  TData = Awaited<ReturnType<typeof measurementDefinitionsLatest>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof measurementDefinitionsLatest>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getMeasurementDefinitionsLatestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof measurementDefinitionsLatest>>
  > = ({ signal }) => measurementDefinitionsLatest({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof measurementDefinitionsLatest>>,
    TError,
    TData
  >;
};

export type MeasurementDefinitionsLatestQueryResult = NonNullable<
  Awaited<ReturnType<typeof measurementDefinitionsLatest>>
>;
export type MeasurementDefinitionsLatestQueryError = AxiosError<unknown>;

/**
 * @summary List the latest measurement for each definition
 */

export function useMeasurementDefinitionsLatest<
  TData = Awaited<ReturnType<typeof measurementDefinitionsLatest>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof measurementDefinitionsLatest>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMeasurementDefinitionsLatestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * List all observations.
 * @summary List all observations
 */
export const observationsList = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Observation[]>> => {
  return axios.default.get(`/v1/observations`, options);
};

export const getObservationsListQueryKey = () => {
  return ["v1", "observations"] as const;
};

export const getObservationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof observationsList>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof observationsList>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getObservationsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof observationsList>>
  > = ({ signal }) => observationsList({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof observationsList>>,
    TError,
    TData
  >;
};

export type ObservationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof observationsList>>
>;
export type ObservationsListQueryError = AxiosError<unknown>;

/**
 * @summary List all observations
 */

export function useObservationsList<
  TData = Awaited<ReturnType<typeof observationsList>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof observationsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getObservationsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * Tries to create a new observation item to storage or fails with 409 conflict if already exists.
 * @summary Create a new observation
 */
export const observationsCreate = (
  observation: MaybeRef<Observation>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Observation>> => {
  observation = unref(observation);

  return axios.default.post(`/v1/observations`, observation, options);
};

export const getObservationsCreateMutationOptions = <
  TError = AxiosError<ApiError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof observationsCreate>>,
    TError,
    { data: Observation },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof observationsCreate>>,
  TError,
  { data: Observation },
  TContext
> => {
  const mutationKey = ["observationsCreate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof observationsCreate>>,
    { data: Observation }
  > = (props) => {
    const { data } = props ?? {};

    return observationsCreate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ObservationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof observationsCreate>>
>;
export type ObservationsCreateMutationBody = Observation;
export type ObservationsCreateMutationError = AxiosError<ApiError>;

/**
 * @summary Create a new observation
 */
export const useObservationsCreate = <
  TError = AxiosError<ApiError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof observationsCreate>>,
      TError,
      { data: Observation },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof observationsCreate>>,
  TError,
  { data: Observation },
  TContext
> => {
  const mutationOptions = getObservationsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Tries to update an observation item to storage.
 * @summary Update an observation
 */
export const observationsUpdate = (
  id: MaybeRef<string>,
  observation: MaybeRef<Observation>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Observation>> => {
  id = unref(id);
  observation = unref(observation);

  return axios.default.put(`/v1/observations/${id}`, observation, options);
};

export const getObservationsUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof observationsUpdate>>,
    TError,
    { id: string; data: Observation },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof observationsUpdate>>,
  TError,
  { id: string; data: Observation },
  TContext
> => {
  const mutationKey = ["observationsUpdate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof observationsUpdate>>,
    { id: string; data: Observation }
  > = (props) => {
    const { id, data } = props ?? {};

    return observationsUpdate(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ObservationsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof observationsUpdate>>
>;
export type ObservationsUpdateMutationBody = Observation;
export type ObservationsUpdateMutationError = AxiosError<unknown>;

/**
 * @summary Update an observation
 */
export const useObservationsUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof observationsUpdate>>,
      TError,
      { id: string; data: Observation },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof observationsUpdate>>,
  TError,
  { id: string; data: Observation },
  TContext
> => {
  const mutationOptions = getObservationsUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List all Todo items from in-memory storage.
 * @summary List all Todo items
 */
export const todosList = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Todo[]>> => {
  return axios.default.get(`/v1/todos`, options);
};

export const getTodosListQueryKey = () => {
  return ["v1", "todos"] as const;
};

export const getTodosListQueryOptions = <
  TData = Awaited<ReturnType<typeof todosList>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof todosList>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getTodosListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof todosList>>> = ({
    signal,
  }) => todosList({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof todosList>>,
    TError,
    TData
  >;
};

export type TodosListQueryResult = NonNullable<
  Awaited<ReturnType<typeof todosList>>
>;
export type TodosListQueryError = AxiosError<unknown>;

/**
 * @summary List all Todo items
 */

export function useTodosList<
  TData = Awaited<ReturnType<typeof todosList>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof todosList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTodosListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * Tries to create a new Todo item to storage or fails with 409 conflict if already exists.
 * @summary Create new Todo
 */
export const todosCreate = (
  newTodo: MaybeRef<NewTodo>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Todo>> => {
  newTodo = unref(newTodo);

  return axios.default.post(`/v1/todos`, newTodo, options);
};

export const getTodosCreateMutationOptions = <
  TError = AxiosError<ApiError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof todosCreate>>,
    TError,
    { data: NewTodo },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof todosCreate>>,
  TError,
  { data: NewTodo },
  TContext
> => {
  const mutationKey = ["todosCreate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof todosCreate>>,
    { data: NewTodo }
  > = (props) => {
    const { data } = props ?? {};

    return todosCreate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TodosCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof todosCreate>>
>;
export type TodosCreateMutationBody = NewTodo;
export type TodosCreateMutationError = AxiosError<ApiError>;

/**
 * @summary Create new Todo
 */
export const useTodosCreate = <
  TError = AxiosError<ApiError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof todosCreate>>,
      TError,
      { data: NewTodo },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof todosCreate>>,
  TError,
  { data: NewTodo },
  TContext
> => {
  const mutationOptions = getTodosCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Mark Todo item done by given id. Return only status 200 on success or 404 if Todo is not found.
 * @summary Mark Todo item done by id
 */
export const todosMarkDone = (
  id: MaybeRef<string>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  id = unref(id);

  return axios.default.put(`/v1/todos/${id}`, undefined, options);
};

export const getTodosMarkDoneMutationOptions = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof todosMarkDone>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof todosMarkDone>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["todosMarkDone"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof todosMarkDone>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return todosMarkDone(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TodosMarkDoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof todosMarkDone>>
>;

export type TodosMarkDoneMutationError = AxiosError<void>;

/**
 * @summary Mark Todo item done by id
 */
export const useTodosMarkDone = <TError = AxiosError<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof todosMarkDone>>,
      TError,
      { id: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof todosMarkDone>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getTodosMarkDoneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a user token
 */
export const usersCreateToken = (
  username: MaybeRef<string>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  username = unref(username);

  return axios.default.post(`/v1/users/${username}/tokens`, undefined, {
    responseType: "text",
    ...options,
  });
};

export const getUsersCreateTokenMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersCreateToken>>,
    TError,
    { username: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersCreateToken>>,
  TError,
  { username: string },
  TContext
> => {
  const mutationKey = ["usersCreateToken"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersCreateToken>>,
    { username: string }
  > = (props) => {
    const { username } = props ?? {};

    return usersCreateToken(username, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersCreateTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersCreateToken>>
>;

export type UsersCreateTokenMutationError = AxiosError<unknown>;

/**
 * @summary Create a user token
 */
export const useUsersCreateToken = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersCreateToken>>,
      TError,
      { username: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof usersCreateToken>>,
  TError,
  { username: string },
  TContext
> => {
  const mutationOptions = getUsersCreateTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
